var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dot-container"},[_c('div',{staticClass:"dots",class:("dots--" + _vm.dotsStyle)},[_c('div',{staticClass:"dot"}),_vm._v(" "),_c('div',{staticClass:"dot"}),_vm._v(" "),_c('div',{staticClass:"dot"})])])}
var staticRenderFns = []

export { render, staticRenderFns }